import comp from "./NotificationCenter";
export default comp;
